var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.stubbed)?_vm._t("content"):_vm._e(),(_vm.stubbed)?_vm._t("stub"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }